// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorService } from './elevator-service';


export class ElevatorServiceMessage implements flatbuffers.IUnpackableObject<ElevatorServiceMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorServiceMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorServiceMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorServiceMessage):ElevatorServiceMessage {
  return (obj || new ElevatorServiceMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorServiceMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorServiceMessage):ElevatorServiceMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorServiceMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorService {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorService.Auto;
}

static startElevatorServiceMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorService) {
  builder.addFieldInt16(0, message, ElevatorService.Auto);
}

static endElevatorServiceMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorServiceMessage(builder:flatbuffers.Builder, message:ElevatorService):flatbuffers.Offset {
  ElevatorServiceMessage.startElevatorServiceMessage(builder);
  ElevatorServiceMessage.addMessage(builder, message);
  return ElevatorServiceMessage.endElevatorServiceMessage(builder);
}

unpack(): ElevatorServiceMessageT {
  return new ElevatorServiceMessageT(
    this.message()
  );
}


unpackTo(_o: ElevatorServiceMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): ElevatorServiceMessageT {
  const t = new ElevatorServiceMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class ElevatorServiceMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorService = ElevatorService.Auto
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorServiceMessage.createElevatorServiceMessage(builder,
    this.message
  );
}

clone(): ElevatorServiceMessageT {
  const obj = new ElevatorServiceMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: ElevatorServiceMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyElevatorServiceMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
